import { useMemo } from "react";
import _ from "lodash";
import { reportsList } from "../../common/util";
import { useGetReportTypeDetailsQuery } from "../../redux/commonApiCalls";

// Chip colour per business unit, so D2C and PTL reports stand apart in the lists
const BUSINESS_UNIT_CHIP_COLOR = { D2C: "info", PTL: "warning" };

// Report name and business unit (D2C / PTL) come from GET reports/types/details;
// reportsList decides which reports are offered and holds their descriptions.
// Sorted D2C first, then PTL, each by name.
export default function useReportsList() {
  const { data: reportTypes } = useGetReportTypeDetailsQuery();
  return useMemo(() => {
    const typeByKey = _.keyBy(reportTypes || [], "key");
    const reports = reportsList.map((r) => {
      const type = typeByKey[r.value.toUpperCase()];
      return {
        ...r,
        label: type?.name || r.label,
        businessUnit: type?.businessUnit,
        tagColor: BUSINESS_UNIT_CHIP_COLOR[type?.businessUnit],
      };
    });
    return _.orderBy(reports, ["businessUnit", "label"]);
  }, [reportTypes]);
}
